import { VIEWED_THRESHOLD } from './constants';

export const mergeProgress = (previous, present) => {
  if (!present) {
    return previous || [];
  }

  if (!previous || previous.length <= 0) {
    return present;
  }

  const mergedProgress = [];
  for (
    let index = 0;
    index < Math.max(previous.length, present.length);
    index++
  ) {
    const currentCount = present[index];
    const previousCount = previous[index];
    // TODO refactor after MVP due to not storing individual sessions
    mergedProgress.push(Math.max(previousCount || 0, currentCount || 0));
  }
  return mergedProgress;
};

export const calculateWatchPercentage = (progress) => {
  const total = (progress || []).length;
  const count = (progress || []).filter((x) => x > 0).length;

  if (count === 0 || progress === 0) {
    return '0.00';
  }

  return (count / total).toFixed(2);
};

export const isComplete = (watchedPercentage) =>
  Number(watchedPercentage) >= VIEWED_THRESHOLD;

export const getStatus = (watchedPercentage) =>
  isComplete(watchedPercentage) ? 'COMPLETE' : 'STARTED';
